import React from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import * as Yup from 'yup';
import { getCookie } from "../../../../services/helper/Helper";
import { Control,actions } from 'react-redux-form';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import moment from 'moment';
import base64  from 'base-64';
import Select from "react-select";
import ReactHtmlParser from 'react-html-parser';
import {getDocumentActivities,previewDocument} from '../../../../actions/documentActivityAction';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {eStoragebaseURL,mediaPath } from "../../../../config";

class DocumentActivity  extends React.Component {	
	constructor(props, context) {
    super(props, context);
	this.state = {
		showModal: false,
	}
	props.getDocumentActivities();
  }
  
	toggleModal(flag)
	{
		if(flag=='open')
		{
			this.setState({ showModal: true });
		}else{
			this.setState({ showModal: false });
		}
		
	}
  
	render(){
		const options = {
		// pageStartIndex: 0,
		  sizePerPage: 25,
		  firstPageText: 'First',
		  prePageText: 'Prev',
		  nextPageText: 'Next',
		  lastPageText: 'Last',
		  hideSizePerPage: true,
		  hidePageListOnlyOnePage: true
    };
		const data = this.props.documentActivity || [];
		const documentData = this.props.documentPreview || [];
		
		const columns = [
		{
			dataField: 'activity_desc',
			text: ' ',
			classes: 'activity',
			headerClasses: 'activity',
			sortCaret: (order, column) => {
			return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
		  }
		},
		{
			dataField: 'created_date',
			text: 'Date ',
			sort: true,
			classes: 'date',
			headerClasses: 'date',
			sortCaret: (order, column) => {
			return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
		  }
		},
		{
			dataField: 'created_time_for_sorting',
			text: 'Time ',
			sort: true,
			classes: 'time',
			headerClasses: 'time',
			sortCaret: (order, column) => {
			// if (!order) return (<i className="fa fa-angle-down"></i>);
			// else if (order === 'asc') return (<i className="fa fa-angle-up"></i>);
			// else if (order === 'desc') return (<i className="fa fa-angle-down" ></i>);
			// return null;
			return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
		  },
			formatter: (value, row, index, field) => {
				return row.created_time
			}
		},
		{
			dataField: 'Preview',
			text: ' ',
			classes: 'preview-document-btn',
			headerClasses: 'preview-document-btn',
			formatter: (value, row) => {
			return (row.status!='Deleted') ? 
					<a href="javascript:;" onClick={() => {this.props.previewDocument(row.status,row.document_id);this.toggleModal('open') }}>Preview Document</a> : '-'
			},
		},
		{
			dataField: 'docket',
			text: ' ',
			classes: 'go-to-docket-btn',
			headerClasses: 'go-to-docket-btn',
			formatter: (value, row) => {
					return (
					<a href="javascript:;" onClick={()=>{this.props.history.push('/publicAccess/docketInfo/'+btoa(row.caseid))}}>Go to Docket</a>
				);    
			},
		},
		];
		const defaultSorted = [{
		  dataField: 'created_time_for_sorting',
		  order: 'desc'
		}];
	return (
			<div className="activity-dashboard-block">
				<div className="activity-dashboard-inner-block">
					<div className="container">
						<div className="col-xs-12">
							<h1 className="title">Document Activity</h1>
						</div>
						<div className="col-xs-12">
								<div className="activity-dashboard-table">
									<BootstrapTable wrapperClasses="boo" keyField='id' data={data} columns={columns} defaultSorted={defaultSorted} pagination={ paginationFactory(options) } noDataIndication={'No records found.'} bordered={false} />
								</div>
						</div>
					</div>
				</div>
			
			<Modal show={this.state.showModal}
					onHide={() => this.handleClose()}
					backdrop="static" id="doc-review"
					className="modal fade">
					<Modal.Header>
						<button type="button" className="close" onClick={() => { this.toggleModal('close') }} ><img src={mediaPath+"close.png"} alt="close" /></button>
						<h4 className="modal-title">Document Name:{documentData.document_name}</h4>
					</Modal.Header>
					<Modal.Body>
						<div className="doc-detail">
									<div className="row">
										<div className="col-xs-3">
											<label>Type:</label>
											<span>{documentData.document_type}</span>
										</div>
										<div className="col-xs-3">
											<label>Docket #:</label>
											<span>{documentData.caseid}</span>
										</div>
										<div className="col-xs-3">
											<label>Date Submitted:</label>
											<span>{documentData.date_submitted}</span>
										</div>
										<div className="col-xs-3">
											<label>Submitted By:</label>
											<span>{documentData.firstname}</span>
										</div>
									</div>
									<div className="row">
										<div className="col-xs-12">
											<label>Description:</label>
											<span>{ReactHtmlParser(documentData.description)}</span>
										</div>
									</div>
								</div>
								<div className="pdf-block" ng-if="filePath">
								<iframe src={eStoragebaseURL+documentData.document_file_path} width="100%" height="350px" ></iframe>
								</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="btn-block">
							<button type="button" className="btn cancel" onClick={() => { this.toggleModal('close') }}>Close</button>
						</div>
					</Modal.Footer>
					</Modal>
					</div>
		)
	}
}

function mapStateToProps(state) {
	//console.log(state);
	return {
	  documentActivity : state.documentActivity.documentActivity,
	  documentPreview : state.documentActivity.documentPreview
  };
}

export default connect(mapStateToProps, {getDocumentActivities,previewDocument})(DocumentActivity);
